module.exports = __webpack_public_path__ + "img/mpyd.309c6c87.jpg";